import React, { useContext, useState } from "react";
import FormTriggers from "../../../layouts/FormTriggers";
import RadioButtons from "../../../layouts/RadioButtons";
import { axios_instance } from "../../../api/axios_instance";
import FormButtons from "./FormButtons";
import { toast } from "react-toastify";
import {
  checkHoldCase,
  getCompletedStepDetails,
  holdCaseMessage,
} from "../../../utils/detail";
import { DetailFormContext } from "../../../ContextAPI/context";

const OtherVerification = ({
  fieldValues,
  stepSelected,
  handleNextStep,
  user,
  isVerificationRequired,
  Message,
  dtsCheckpoints,
  fetchCaseData,
  caseDetails,
}) => {
  const { panelTitle, stepTitle, setDetailFormButtonClicked } =
    useContext(DetailFormContext);
  const { stepDetails, visibilityObj, requiredSubStepFields } = fieldValues;
  const { checklist, btnDraftType } = stepDetails;
  const {
    finance_lead_id,
    id,
    stage,
    sub_stage,
    insurance,
    bank_id,
    is_prepayment_raised,
    is_dealer_vcf,
    is_company_noc,
    is_puc,
    is_chassis_print,
    total_tranche,
    step_details,
    maker_id,
  } = caseDetails;

  const initialState = {
    isDealerVcf: is_dealer_vcf,
    isCompanyNoc: is_company_noc,
    isPUC: is_puc,
    isChassisPrint: is_chassis_print,
    totalTranche: total_tranche ? total_tranche : "0",
  };

  const [state, setState] = useState(initialState);

  const isDealerVcfVisible =
    requiredSubStepFields?.dealer_vcf?.is_visible === 1 &&
    visibilityObj?.is_dealer_vcf;

  const isCompanyNocVisible =
    requiredSubStepFields?.company_noc?.is_visible === 1 &&
    visibilityObj?.is_company_noc;

  const isPUCVisible =
    requiredSubStepFields?.puc?.is_visible === 1 && visibilityObj?.is_puc;

  const isChassisPrintVisible =
    requiredSubStepFields?.chassis_print?.is_visible === 1 &&
    visibilityObj?.is_chassis_print;

  const isTotalTrancheVisible =
    requiredSubStepFields?.total_tranche?.is_visible === 1 &&
    visibilityObj?.total_tranche;

  const calculatedIsVerificationRequired =
    isDealerVcfVisible ||
    isCompanyNocVisible ||
    isPUCVisible ||
    isChassisPrintVisible ||
    isTotalTrancheVisible;

  const saveDetails = async () => {
    const stepDetails = getCompletedStepDetails(
      step_details,
      sub_stage,
      stepSelected
    );
    await axios_instance({
      url: "/dts/dtsAdditionalDetails",
      method: "POST",
      data: {
        finance_lead_id: +finance_lead_id,
        form: stepSelected,
        stage: +stage,
        sub_stage: +sub_stage,
        type: btnDraftType,
        step_details: stepDetails,
        insurance,
        bank_id,
        is_prepayment_raised,
        is_dealer_vcf: state.isDealerVcf,
        is_company_noc: state.isCompanyNoc,
        is_puc: state.isPUC,
        is_chassis_print: state.isChassisPrint,
        total_tranche: state.totalTranche,
        disbursement_id: +id,
      },
    });
    await fetchCaseData();
  };

  const handleSaveAndNext = async () => {
    try {
      const checkHoldStatus = await checkHoldCase(
        finance_lead_id,
        maker_id,
        sub_stage
      );
      toast.dismiss();
      if (checkHoldStatus) {
        return toast.error(holdCaseMessage, { theme: "colored" });
      }
      setDetailFormButtonClicked(true);
      await saveDetails();
      toast(<Message />);
      handleNextStep();
    } catch (error) {
    } finally {
      setDetailFormButtonClicked(false);
    }
  };

  const handleSaveAsDraft = async () => {
    try {
      const checkHoldStatus = await checkHoldCase(
        finance_lead_id,
        maker_id,
        sub_stage
      );
      toast.dismiss();
      if (checkHoldStatus) {
        return toast.error(holdCaseMessage, { theme: "colored" });
      }
      setDetailFormButtonClicked(true);
      await saveDetails();
      toast(<Message />);
    } catch (error) {
    } finally {
      setDetailFormButtonClicked(false);
    }
  };
  return (
    <>
      <div
        className="table-responsive chklist-box-scroll mCustomScrollbar _mCS_1 mCS-autoHide mCS_no_scrollbar"
        data-mcs-theme="minimal-dark"
      >
        {isVerificationRequired && calculatedIsVerificationRequired ? (
          <div
            id="mCSB_1"
            className="mCustomScrollBox mCS-minimal-dark mCSB_vertical mCSB_outside"
          >
            <div
              id="mCSB_1_container"
              className="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
            >
              <form id="other_verification">
                <table className="table table-bordered disburse-table">
                  <thead>
                    <tr>
                      <th width="76%" colSpan="2">
                        {panelTitle} - {stepTitle}
                      </th>
                      {checklist && <th width="24%">L1</th>}
                    </tr>
                  </thead>
                  <tbody className="form-table">
                    {isDealerVcfVisible ? (
                      <tr>
                        <RadioButtons
                          label={requiredSubStepFields?.dealer_vcf?.name}
                          isRequired={false}
                          className="rto"
                          name="is_dealer_vcf"
                          disabled={
                            requiredSubStepFields?.dealer_vcf?.is_editable === 1
                              ? stepDetails.disableMaker
                              : "disabled"
                          }
                          yesChecked={state.isDealerVcf === 1 ? true : false}
                          noChecked={state.isDealerVcf === 0 ? true : false}
                          onYesClicked={() =>
                            setState({ ...state, isDealerVcf: 1 })
                          }
                          onNoClicked={() =>
                            setState({ ...state, isDealerVcf: 0 })
                          }
                        />
                        {checklist ? (
                          <FormTriggers
                            triggerName="is_dealer_vcf"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    ) : (
                      ""
                    )}

                    {isCompanyNocVisible ? (
                      <tr>
                        <RadioButtons
                          label={requiredSubStepFields?.company_noc?.name}
                          isRequired={false}
                          className="rto"
                          name="is_company_noc"
                          disabled={
                            requiredSubStepFields?.company_noc?.is_editable ===
                            1
                              ? stepDetails.disableMaker
                              : "disabled"
                          }
                          yesChecked={state.isCompanyNoc === 1 ? true : false}
                          noChecked={state.isCompanyNoc === 0 ? true : false}
                          onYesClicked={() =>
                            setState({ ...state, isCompanyNoc: 1 })
                          }
                          onNoClicked={() =>
                            setState({ ...state, isCompanyNoc: 0 })
                          }
                        />
                        {checklist ? (
                          <FormTriggers
                            triggerName="is_company_noc"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    ) : (
                      ""
                    )}

                    {isPUCVisible ? (
                      <tr>
                        <RadioButtons
                          label={requiredSubStepFields?.puc?.name}
                          isRequired={false}
                          className="rto"
                          name="is_puc"
                          disabled={
                            requiredSubStepFields?.puc?.is_editable === 1
                              ? stepDetails.disableMaker
                              : "disabled"
                          }
                          yesChecked={state.isPUC === 1 ? true : false}
                          noChecked={state.isPUC === 0 ? true : false}
                          onYesClicked={() => setState({ ...state, isPUC: 1 })}
                          onNoClicked={() => setState({ ...state, isPUC: 0 })}
                        />
                        {checklist ? (
                          <FormTriggers
                            triggerName="is_puc"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    ) : (
                      ""
                    )}

                    {isChassisPrintVisible ? (
                      <tr>
                        <RadioButtons
                          label={requiredSubStepFields?.chassis_print?.name}
                          isRequired={false}
                          className="rto"
                          name="is_chassis_print"
                          disabled={
                            requiredSubStepFields?.chassis_print
                              ?.is_editable === 1
                              ? stepDetails.disableMaker
                              : "disabled"
                          }
                          yesChecked={state.isChassisPrint === 1 ? true : false}
                          noChecked={state.isChassisPrint === 0 ? true : false}
                          onYesClicked={() =>
                            setState({ ...state, isChassisPrint: 1 })
                          }
                          onNoClicked={() =>
                            setState({ ...state, isChassisPrint: 0 })
                          }
                        />
                        {checklist ? (
                          <FormTriggers
                            triggerName="is_chassis_print"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    ) : (
                      ""
                    )}

                    {isTotalTrancheVisible ? (
                      <tr>
                        <td>{requiredSubStepFields?.total_tranche?.name}</td>
                        <td>
                          <div className="input-append date input-group input-sm">
                            <input
                              type="text"
                              name="total_tranche"
                              id=""
                              className="form-control "
                              placeholder=""
                              disabled={
                                requiredSubStepFields?.total_tranche
                                  ?.is_editable === 1
                                  ? stepDetails.disableMaker
                                  : "disabled"
                              }
                              value={state.totalTranche}
                              onChange={(e) =>
                                setState({
                                  ...state,
                                  totalTranche: e.target.value,
                                })
                              }
                            />
                          </div>
                          <div
                            className="errorTxt"
                            id="error_total_tranche"
                          ></div>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="total_tranche"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    ) : (
                      ""
                    )}
                  </tbody>
                </table>
              </form>
            </div>
          </div>
        ) : (
          <div className="disburse-table no-form">
            There are no verification required in this section. Please click
            Next/Skip to proceed
          </div>
        )}
      </div>
      <FormButtons
        caseDetails={caseDetails}
        user={user}
        stepDetails={stepDetails}
        handleNextButtonClick={handleNextStep}
        handleSaveAndNext={handleSaveAndNext}
        handleSaveAsDraft={handleSaveAsDraft}
        isVerificationRequired={calculatedIsVerificationRequired}
        isReadOnlyUser={fieldValues.isReadOnlyUser}
      />
    </>
  );
};

export default OtherVerification;
